export default "__VITE_ASSET__oASy_SsU__"